export default  [

  {
    path: 'tijian_company/tijian-company-list',
    meta: {pageTitle: '体检中心管理', leftMenuIndex: 'admin_tijian_company_tijian-company-list'},
    component: () => import('@/views/admin/tijian_company/TijianCompanyList')
  },
  {
    path: 'tijian_company/tijian-company-user-list',
    meta: {pageTitle: '体检中心体检人员管理', leftMenuIndex: 'admin_tijian_company_tijian-company-user-list'},
    component: () => import('@/views/admin/tijian_company/TijianCompanyUserList')
  },

  {
    path: 'tijian_company/tijian-company-project-list',
    meta: {pageTitle: '体检中心体检项管理', leftMenuIndex: 'admin_tijian_company_tijian-company-project-list'},
    component: () => import('@/views/admin/tijian_company/TijianCompanyProjectList')
  },
  {
    path: 'tijian_company/tijian-company-taocan-list',
    meta: {pageTitle: '体检中心套餐管理', leftMenuIndex: 'admin_tijian_company_tijian-company-taocan-list'},
    component: () => import('@/views/admin/tijian_company/TijianCompanyTaocanList')
  },
  {
    path: 'tijian_company/tijian-company-login-user-list',
    meta: {pageTitle: '体检中心登录人员管理', leftMenuIndex: 'admin_tijian_company_tijian-company-login-user-list'},
    component: () => import('@/views/admin/tijian_company/TijianCompanyLoginUserList')
  },

  {
    path: 'tijian_company/tijian-company-zhizheng-list',
    meta: {pageTitle: '体检中心制证管理', leftMenuIndex: 'admin_tijian_company_tijian-company-zhizheng-list'},
    component: () => import('@/views/admin/tijian_company/TijianCompanyZhizhengList')
  },
  {
    path: 'tijian_company/jkz-list',
    meta: {pageTitle: '体检中心健康证管理', leftMenuIndex: 'admin_tijian_company_jkz-list'},
    component: () => import('@/views/admin/tijian_company/JkzList')
  },
];



// WEBPACK FOOTER //
// ./src/router/modules/tijian_company.js